export default [
    {
        title: "Menu principal",
        icon: "ApertureIcon",
        route: "menu",
        requiresAdmin: true,
        requiresInvitado: true
    }
];
